/**
 * Media URL resolution — mirrors Flutter AppConstants.fixApiUrl + app-settings.
 */

let mediaUseS3 = false;
let mediaPublicBaseUrl = (
  process.env.REACT_APP_MEDIA_PUBLIC_BASE_URL ||
  process.env.REACT_APP_API_BASE_URL?.replace(/\/api\/v1\/user\/?$/, "") ||
  ""
).replace(/\/+$/, "");
let mediaLocalStorageUrlPrefix = "";

export function configureMediaSettings({
  mediaUseS3: useS3,
  mediaPublicBaseUrl: publicBase,
  mediaLocalStorageUrlPrefix: storagePrefix,
} = {}) {
  if (typeof useS3 === "boolean") {
    mediaUseS3 = useS3;
  }
  if (typeof publicBase === "string" && publicBase.trim() !== "") {
    mediaPublicBaseUrl = publicBase.trim().replace(/\/+$/, "");
  }
  if (typeof storagePrefix === "string") {
    mediaLocalStorageUrlPrefix = storagePrefix.trim().replace(/^\/+|\/+$/g, "");
  }
}

export function getMediaUseS3() {
  return mediaUseS3;
}

/**
 * Browser-ready URL for profile, cover, FAL, or listing media.
 */
export function resolveMediaUrl(url) {
  if (url === null || url === undefined) {
    return "";
  }
  const cleaned = String(url).trim();
  if (!cleaned) {
    return "";
  }

  if (cleaned.startsWith("http://") || cleaned.startsWith("https://")) {
    return cleaned;
  }

  if (
    cleaned.startsWith("/storage/") ||
    (!cleaned.startsWith("http") && cleaned.startsWith("storage/"))
  ) {
    const base = mediaPublicBaseUrl.replace(/\/+$/, "");
    const path = cleaned.startsWith("/") ? cleaned : `/${cleaned}`;
    return base ? `${base}${path}` : path;
  }

  const path = cleaned.startsWith("/") ? cleaned.substring(1) : cleaned;
  if (!path.startsWith("app_data/")) {
    const base = mediaPublicBaseUrl.replace(/\/+$/, "");
    return base ? `${base}/${path}` : path;
  }

  if (mediaUseS3) {
    const base = mediaPublicBaseUrl.replace(/\/+$/, "");
    return base ? `${base}/${path}` : path;
  }

  const origin = mediaPublicBaseUrl.replace(/\/+$/, "");
  if (!origin) {
    return path;
  }
  const prefix = mediaLocalStorageUrlPrefix;
  if (prefix) {
    return `${origin}/storage/${prefix}/${path}`;
  }
  return `${origin}/storage/${path}`;
}
